import h_i18n from '@/utils/Internationalization';
import { computed } from 'vue';

export const mounthArray = computed(() => [
  {
    valueId: '1',
    valueName: h_i18n('fccc2b4ac9cd71904395042cd0f3fd92')
  },
  {
    valueId: '2',
    valueName: h_i18n('c1d13f1d962efb0dd59f4f1e9f9570c9')
  },
  {
    valueId: '3',
    valueName: h_i18n('c4767bc3ad5c6812a8ea302e6126d988')
  },
  {
    valueId: '4',
    valueName: h_i18n('3eaf4b307f8f2507e6849f991efe596e')
  },
  {
    valueId: '5',
    valueName: h_i18n('0545f138f0f61021efc3d3190d955015')
  },
  {
    valueId: '6',
    valueName: h_i18n('f2422a6e4299609a1b1cf3b3fcaf9282')
  },
  {
    valueId: '7',
    valueName: h_i18n('464bab7f82a4361e017a73dd6b958916')
  },
  {
    valueId: '8',
    valueName: h_i18n('81017142849e31d0ca86c31c6f62a00e')
  },
  {
    valueId: '9',
    valueName: h_i18n('4b592d5efd59199a8e6b4ad57ecc84c2')
  },
  {
    valueId: '10',
    valueName: h_i18n('f544c3992587891eaefa4dce866bfebd')
  },
  {
    valueId: '11',
    valueName: h_i18n('57c4475588f6c2c44d526eb338720c3c')
  },
  {
    valueId: '12',
    valueName: h_i18n('c0615eb33be499a472b1b1f1befd1db1')
  }
]);

export function getYearsArray() {
  var currentDate = new Date(); // 获取当前日期对象
  var currentYear = currentDate.getFullYear(); // 获取当前年份
  var yearsArray = []; // 存放结果的数组
  for (var i = currentYear; i >= currentYear - 23; i--) {
    yearsArray.push({ valueId: i, valueName: `${i}${h_i18n('465260fe80b0c3338d06194bb7a94446')}` }); // 将每一年添加到数组中
  }
  return yearsArray;
}

export const questionNode = computed(() => [
  {
    valueId: '1427',
    valueName: h_i18n('552cacb8043adc182c107be1712b7a79')
  },
  {
    valueId: '1363',
    valueName: h_i18n('38484a93d62fdfdd5dc808da53657825')
  },
  {
    valueId: '1364',
    valueName: h_i18n('498bd05ebc689dfde8c4a3a59ace4a42')
  },
  {
    valueId: '1365',
    valueName: h_i18n('9f50ccd8efc555216580ff1a87051f5a')
  },
  {
    valueId: '1366',
    valueName: h_i18n('404f4937bb136f55ca8596d39c0966df')
  },
  {
    valueId: '1383',
    valueName: h_i18n('2d4b2c6a6673b0508f2b1b4e1e5bbc34')
  },
  {
    valueId: '1384',
    valueName: h_i18n('5824ebd0c801a8747a01bb15d56cfc9e')
  },
  {
    valueId: '1385',
    valueName: h_i18n('f8a9d8098b45c2919f6c4fe68b56245b')
  },
  {
    valueId: '1386',
    valueName: h_i18n('08343418ab3446132f4f9514ad9fb78d')
  },
  {
    valueId: '1407',
    valueName: h_i18n('334770dac951ab0b7160c360df89bcda')
  },
  {
    valueId: '1408',
    valueName: h_i18n('eff58a5595a5530a8fc292c9f903a022')
  },
  {
    valueId: '1417',
    valueName: h_i18n('b22c4a1102b856b459bae67cb5dac3e4')
  }
  // {
  //   valueId:'2174',
  //   valueName:'虚假资料'
  // },
  // {
  //   valueId:'2175',
  //   valueName:'重大质量降标'
  // },
  // {
  //   valueId:'2175',
  //   valueName:'水、电、火安全问题'
  // },
]);

export const badStatusList = computed(() =>
  [
    {
      valueId: 'N',
      valueName: h_i18n('8f8ed64769bf633cc18799b8f3787f24')
    },
    {
      valueId: 'Y',
      valueName: h_i18n('1789ffa8dc0f942e61bba0ade2c7f44a')
    },
    {
      valueId: 'T',
      valueName: h_i18n('9e6c965bb882233a6fa85c2ddc1837ce')
    },
    {
      valueId: 'NULL',
      valueName: h_i18n('2a2772fa8f6d68423b4656905884c5b4')
    }
  ]);

export const eachOtherStatus = computed(() => [
  {
    valueId: '0',
    valueName: h_i18n('1a88ac0ce7cda47b71f0703ade4b6d23')
  },
  {
    valueId: '1',
    valueName: h_i18n('ce470d57ea7508bf969b5d7f94a346f4')
  }
]);